import { render, staticRenderFns } from "./InvoicesWrapper.vue?vue&type=template&id=e843356c&lang=pug&"
import script from "./InvoicesWrapper.vue?vue&type=script&lang=js&"
export * from "./InvoicesWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports